export default __webpack_public_path__ + "static/media/IMG_2302.d49a7c38.JPG";